import React, { useEffect, useState } from 'react'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { Tasks, GlobalCheckList } from '../StudentManagement'
import { getIdData } from '../../lib/studentinfo'

// Parent view for a single student's detailed agenda & checklist
const ParentAgenda = () => {
	const { user } = useAuth()
	const [isStudent12, setIsStudent12] = useState(false)
	const [loading, setLoading] = useState(true)

	const studentId = user?.studentId

	useEffect(() => {
		// If there is no linked student, just stop loading and skip request
		if (!studentId) {
			setLoading(false)
			setIsStudent12(false)
			return
		}

		const fetchStudentInfo = async () => {
			try {
				setLoading(true)
				const info = await getIdData(studentId)
				if (info && info.length > 0 && info[0].role === 'Student12') {
					setIsStudent12(true)
				}
			} catch (error) {
				console.error('Error fetching student data for parent agenda:', error)
			} finally {
				setLoading(false)
			}
		}

		fetchStudentInfo()
	}, [studentId])

	if (!studentId) {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<div className="card">
							<div className="card-body">
								<h5 className="card-title mb-3">Agenda</h5>
								<p className="mb-0">No active student is linked to this parent account.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	if (loading) {
		return (
			<div className="container-fluid">
				<div className="text-center">
					<div className="spinner-border" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-2">Loading agenda...</p>
				</div>
			</div>
		)
	}

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					{/* Checklist only for Student12, same rule as student/instructor view */}
					{isStudent12 && <GlobalCheckList slug={studentId} isStudent={true} />}

					<div className="settings-widget profile-details">
						<div className="settings-inner-blk p-0">
							{/* Detailed agenda/tasks list reused from StudentManagement */}
							<Tasks slug={studentId} isStudentView={true} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export { ParentAgenda }


